import React from 'react'

const RegionCardHeader = (props) => {
  return (
    <div className={`card-header ${!!props.classNames ? props.classNames : ""}`}>
      <h2 className={`card-title-lg ${!!props.titleClasses ? props.titleClasses : ""}`}>
        {props.title}
      </h2>
      {props.children}
    </div>
  );
}

export default RegionCardHeader;